module.exports = __webpack_public_path__ + "static/media/searchIcon.1b903089.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/searchIcon.svg
// module id = 1953
// module chunks = 0